import header from "./header";
import home from "./home";
import scripDetail from "./common/ScripDetailReducer";
import footer from "./footer";
import holdingReport from "./Reports/HoldingReport";
import positionReport from "./Reports/PositionReport";
import dashboardSummary from "./Reports/dashboardSummary";
import understandSection from "./Reports/UnderstandingSection";
import pnlReport from "./Reports/PNLReport";
import pnltranasactionReport from "./Reports/PNLTransactionReport";
import taxReport from "./Reports/TaxReport";
import accountDetailsReducer from "./userdetail";
import jwtTokenNestTraderReducer from "./JwtTokenNestReducer";
import markets from "../feature/Markets/markets";
import extPlatDataRetrieveReducer from "./ExtPlatDataRetrieveReducer";
import staticFooter from "./StaticFooter";
import watchList from "@frameworks/web/redux/feature/WatchList/Reducers/watchList";
import LoginFlow from "@frameworks/web/redux/feature/LoginFlow/Reducers/LoginFlow";
import Contract from "@frameworks/web/redux/reducers/Reports/ContractStatement";
import TOCJourney from "@frameworks/web/redux/feature/TOCJourney/Reducers/TOCJourney";
import BasicProfile from "@frameworks/web/redux/feature/BasicProfile/reducers/BasicProfile";
import EDIS from "../feature/EDIS/Reducers/EDIS";
import TransactionHistory from "@frameworks/web/redux/reducers/Reports/TransactionHistory";
import SubscriptionReport from "@frameworks/web/redux/reducers/Reports/SubscriptionReport/index";
import fundTransfer from "@frameworks/web/redux/feature/FundTransfer/Reducers/FundTransfer";
import liveNews from "@frameworks/web/redux/feature/LiveNews/Reducers/LiveNews";
import orderBook from "@frameworks/web/redux/feature/OrderBook/orderBook";
import epledge from "@frameworks/web/redux/feature/Epledge/Reducers/Epledge";
import tools from "@frameworks/web/redux/feature/Tools/tools";
import eventCalendarReducer from "@frameworks/web/redux/feature/EventCalendar/Reducers/eventCalendar";
import SGBReducer from "../feature/Offers/SGB/Reducers/sgbReducer";
import ticketPortal from "@frameworks/web/redux/feature/TicketPortal/Reducers/TicketPortal";
import LedgerReport from "@frameworks/web/redux/reducers/Reports/LedgerReport";
import DpInterest from "./Reports/DpInterest";
import DpBills from "./Reports/DpBills";
import alerts from "@frameworks/web/redux/feature/Alerts/Alerts";
import postLogin from "@frameworks/web/redux/feature/PostLogin/PostLoginReducer";
import offerings from "@frameworks/web/redux/feature/Offers/OffersReducer";
import quotes from "@frameworks/web/redux/feature/Quotes/Quote";
import AccountOverview from "./Reports/AccountOverview/AccountOverview";
import Holding from "./Reports/CoreReports/HoldingReducer";
import PnlReport from "./Reports/CoreReports/ProfitAndlossReducer";
import DownloadNSendEmailReport from "./Reports/CoreReports/DownloadNSendEmailReport";
import taxReportReducer from "./Reports/CoreReports/taxReportReducer";
import Family from "./Reports/FamilyTagging";
export default {
    header,
    home,
    footer,
    scripDetail,
    holdingReport,
    positionReport,
    understandSection,
    pnlReport,
    pnltranasactionReport,
    taxReport,
    accountDetailsReducer,
    jwtTokenNestTraderReducer,
    markets,
    extPlatDataRetrieveReducer,
    dashboardSummary,
    staticFooter,
    watchList,
    LoginFlow,
    Contract,
    TOCJourney,
    BasicProfile,
    EDIS,
    orderBook,
    epledge,
    tools,
    ticketPortal,
    TransactionHistory,
    SubscriptionReport,
    LedgerReport,
    DpInterest,
    DpBills,
    eventCalendarReducer,
    offerings,
    fundTransfer,
    SGB: SGBReducer,
    liveNews,
    alerts,
    postLogin,
    quotes,
    AccountOverview,
    holdingRevamp: Holding,
    pnlRevamp: PnlReport,
    downloadRevamp: DownloadNSendEmailReport,
    taxRevamp: taxReportReducer,
    FamilyTagging: Family,
};
